import { useCallback, useEffect, useState } from "react";
import { TipoMaterialN1 } from "../types/materiaisN1.types";
import { ITravaPlanilhaN1, obterTravaPlanilha } from "../services/materiaisN1";

/**
 * Plano 14/10/2026 (Frente 4): exclusão mútua planilha × edição manual por empresa + tipo
 * (P2 do PO, 13/10). Devolve o estado do tipo informado — `null` enquanto carrega ou sem tipo.
 * `recarregar` serve às telas que mudam o estado (importar/remover planilha).
 */
export const useTravaPlanilhaN1 = (
  tipoMaterial?: TipoMaterialN1 | null
): { trava: ITravaPlanilhaN1 | null; recarregar: () => void } => {
  const [trava, setTrava] = useState<ITravaPlanilhaN1 | null>(null);
  const [versao, setVersao] = useState(0);

  useEffect(() => {
    if (!tipoMaterial) {
      setTrava(null);
      return;
    }

    let ativo = true;
    obterTravaPlanilha(tipoMaterial).then((resposta) => {
      if (ativo) setTrava(resposta);
    });

    return () => {
      ativo = false;
    };
  }, [tipoMaterial, versao]);

  const recarregar = useCallback(() => setVersao((v) => v + 1), []);

  return { trava, recarregar };
};
